import React, { useEffect, useState } from 'react'

export const SafeFlagImg = ({ className, country, countryDisplayName }) => (
  <SafeImg
    className={className}
    src={`/images/locations/${country}.png`}
    title={countryDisplayName}
  />
)

export const SafeStickerImg = ({ className, stickerName }) => (
  <SafeImg
    className={className}
    src={`/images/stickers/${stickerName}.png`}
  />
)

export const SafeImg = ({ src, title, className }) => {
  const [imageError, setImageError] = useState(false)
  useEffect(() => { setImageError(false) }, [src])

  if (imageError) return null

  return (
    <img
      src={src}
      title={title}
      className={className}
      onError={() => setImageError(true)}
    />
  )
}